import { render } from "./ReferralInfo.vue?vue&type=template&id=48bf96df&scoped=true&lang=pug"
import script from "./ReferralInfo.vue?vue&type=script&lang=js"
export * from "./ReferralInfo.vue?vue&type=script&lang=js"

import "./ReferralInfo.vue?vue&type=style&index=0&id=48bf96df&scoped=true&lang=scss"
import "./ReferralInfo.vue?vue&type=style&index=1&id=48bf96df&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bf96df"]])

export default __exports__